import * as React from 'react';
import { compose } from 'recompose';
import { TransactionInfo } from 'components/PositionDetailsModal/components/TransactionInfo';
import { DateTime } from 'components/PositionDetailsModal/components/DateTime';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import MoneyView from 'shared/components/MoneyView';
import { Investment_PositionSellStatus, Investment_IdeaCategory } from 'types/common';
import { Fees } from '../Fees';
import { QuantityAsset } from '../QuantityAsset';
import { IdeaPositionDetailsSellFragment } from './__generated__/IdeaPositionDetailsSellFragment';

interface Props {
  transaction: IdeaPositionDetailsSellFragment;
  ticker?: string | null;
  category?: Investment_IdeaCategory;
}

type Enhanced = Props & InjectedTranslateProps;

const enhance = compose<Enhanced, Props>(translate);

function Sell({ t, transaction, ticker, category }: Enhanced) {
  if (
    transaction.__typename !== 'Investment_BuyAndHoldPositionSell' ||
    !transaction.amount ||
    !transaction.netAmount ||
    !transaction.quantity ||
    transaction.status !== Investment_PositionSellStatus.FILLED
  ) {
    return null;
  }

  const price = {
    ...transaction.amount,
    value: transaction.amount.value / transaction.quantity,
  };

  const date = transaction.auditInfo.updatedAt || transaction.auditInfo.createdAt;

  return (
    <TransactionInfo
      title={t('Selling')}
      items={[
        <QuantityAsset
          ticker={ticker}
          category={category}
          quantity={transaction.quantity}
          data-testid="quantity"
        />,
        <MoneyView cents data-testid="price">
          {price}
        </MoneyView>,
        <MoneyView cents data-testid="amount">
          {transaction.amount}
        </MoneyView>,
        <Fees transaction={transaction} />,
        <MoneyView sign cents data-testid="net-amount">
          {transaction.netAmount}
        </MoneyView>,
        <DateTime>{date}</DateTime>,
      ]}
      data-testid="sell"
    />
  );
}

export default enhance(Sell);
